import { DevelopersHome, EOrderAPI, VictronWebsiteAPI, VRMAPI } from '@developers/routes';
import { NotFound } from '@routes/NotFound';
import { Route, Routes } from 'react-router-dom';

export const DevelopersRoutes = () => {
    return (
        <Routes>
            <Route index element={<DevelopersHome />} />
            <Route path="api-eorder" element={<EOrderAPI />} />
            <Route path="api-victron" element={<VictronWebsiteAPI />} />
            <Route path="api-vrm" element={<VRMAPI />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
